


















import { computed, defineComponent, ref } from '@vue/composition-api';
import CompositeDialog from '@/components/composite/CompositeDialog.vue';
import PatientResultsScoringSQI from '@/components/patient/results/PatientResultsScoringSQI.vue';

// Import types ------------------------------------------------------------------------------------
import type { DialogId } from '@/plugins/podocore/modules/bus/bus.module';
// ------------------------------------------------------------------------------------------------
export default defineComponent({
  name: 'DialogAnalysisCommentUpdate',
  components: {
    CompositeDialog,
    PatientResultsScoringSQI
  },
  setup() {
    const dialogId: DialogId = 'analysis-SQI';
    const rDialog = ref<any>(null);

    const analysis = computed(() => rDialog?.value?.meta?.analysis);

    function closeDialog() {
      rDialog.value.close();
    }

    return {
      rDialog,
      dialogId,
      closeDialog,
      analysis
    };
  }
});
